// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__JNK7h","modalHeaderContainer":"styles_modalHeaderContainer__gYGqH","buttonForgotPassword":"styles_buttonForgotPassword__WbZk4"};